import { JSX, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useInView } from "react-intersection-observer";

import { useGetFavorites } from "@/hooks/api/feed.hooks";

import NoData from "../NoData";
import MovieCardSkeleton from "../cards/MovieCard/MovieCard.skeleton";
import MoviesGrid from "../helpers/MoviesGrid";

const ContentSectionFavorites = (): JSX.Element => {
  const { data: favorites, fetchNextPage, hasNextPage, isFetching } = useGetFavorites(48);

  const { ref: inViewRef, inView } = useInView();
  const { t } = useTranslation();

  const flattenedData = favorites?.pages.flatMap((page) => page.results) || [];

  useEffect(() => {
    if (inView && hasNextPage) {
      fetchNextPage();
    }
  }, [inView, hasNextPage, fetchNextPage, isFetching]);

  return (
    <>
      <section className={"mt-8 max-lg:py-0"}>
        {flattenedData && flattenedData.length ? (
          <MoviesGrid content={flattenedData} />
        ) : !isFetching ? (
          <NoData message={t("NoData.favorites")} />
        ) : null}
        {isFetching ? (
          <div className={"movies-grid mt-[1rem]"}>
            {[...Array(24).keys()].map((_, index) => (
              <MovieCardSkeleton key={index} />
            ))}
          </div>
        ) : null}
        {flattenedData.length ? <div ref={inViewRef} className={"h-px w-full"} /> : null}
      </section>
    </>
  );
};

export default ContentSectionFavorites;
